import React, { Fragment } from 'react';
import Skeleton from 'ati-ui-react/components/Skeleton';
import * as styles from './DescriptionLoading.scss';

const DescriptionLoading = () => (
  <Fragment>
    <div className={styles.headingContainer}>
      <Skeleton className={styles.heading} />
    </div>
    <div className={styles.paragraphContainer}>
      <Skeleton className={styles.first} />
      <Skeleton className={styles.second} />
      <Skeleton className={styles.third} />
    </div>
  </Fragment>
);

export default DescriptionLoading;
